import React from "react";
import "./Spinner.css";

const Spinner = () => (
  <React.Fragment>
    <div className="spinner">
      <span className="ball-1"></span>
      <span className="ball-2"></span>
      <span className="ball-3"></span>
      <span className="ball-4"></span>
      <span className="ball-5"></span>
      <span className="ball-6"></span>
      <span className="ball-7"></span>
      <span className="ball-8"></span>
    </div>
  </React.Fragment>

  // <Dimmer active>
  //   <Loader
  //     size="huge"
  //     content={"Hold tight,we are unfolding your stories..."}
  //   />
  // </Dimmer>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/Spinner.js